var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MySubmissionsTable',{attrs:{"formId":_vm.f}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }